export interface Partner {
  name: string;
  href: string;
  domain: string;
  logo: string;
}

// TODO: скачать эти логотипы и положить в /public/partners/,
// заменить внешние URL на локальные пути (/partners/carpro.png и т.д.)
// до деплоя в продакшн — внешний CDN ненадёжен для production.
export const partners: Partner[] = [
  {
    name: "CarPro",
    href: "https://carpro.global/",
    domain: "carpro.global",
    logo: "https://cdn.phototourl.com/free/2026-07-22-19a66402-0a06-44fe-a251-ec4393ba4542.png",
  },
  {
    name: "XPEL",
    href: "https://www.xpel.com/",
    domain: "xpel.com",
    logo: "https://cdn.phototourl.com/free/2026-07-22-89828aa4-6724-4823-b456-d5b0f7473ab2.png",
  },
  {
    name: "Llumar",
    href: "https://llumar.com/",
    domain: "llumar.com",
    logo: "https://llumar.com/content/experience-fragments/eastman-llumar/en/site/header/master/_jcr_content/root/header/headcontainer/navcontainer/image.coreimg.png/1773332155607/llumarlogo-primary-fullcolor-rgb.png",
  },
  {
    name: "SunTek",
    href: "https://suntekfilms.com/",
    domain: "suntekfilms.com",
    logo: "https://cdn.phototourl.com/free/2026-07-22-1249699b-0c7b-497e-aafb-32f65faed03d.png",
  },
  {
    name: "UPPF",
    href: "https://www.uppf.com/",
    domain: "uppf.com",
    logo: "https://cdn.phototourl.com/free/2026-07-22-fe8bd776-2752-4c8c-9eea-7ad8d6c1c4c0.png",
  },
  {
    name: "Karmashield",
    href: "https://karmashield-films.com/",
    domain: "karmashield-films.com",
    logo: "https://karmashield-films.com/images/karmashield-logo-120.png",
  },
];
